import { ViewSupplyPoints, type CountableApiResponse, type SerializedEstablishment, type SerializedSupplyPointByView } from '@enmon/commons/lib/enmon';
import { BaseApiClient } from '../baseApiClient';
import type { SupplyPointsFilter } from '../../../types/backendGateway/supplyPointsApi';

type PopulatedSupplyPoint = SerializedSupplyPointByView["dropdown"] & {
  establishment: Pick<SerializedEstablishment, '_id' | 'name' | 'code'>;
}

export type GetSupplyPointsMetadataResponse = CountableApiResponse<PopulatedSupplyPoint[]>;

export class SupplyPointsApiClient extends BaseApiClient {
  constructor(jwt: string) {
    super('enmon-tools/supply-points', undefined, jwt);
  }

  public async getMetadata(filter: SupplyPointsFilter): Promise<GetSupplyPointsMetadataResponse> {
    const response = await this.axios.get<GetSupplyPointsMetadataResponse>('metadata', {
      params: {...filter, view: ViewSupplyPoints.Dropdown},  });

    return response.data;
  }
}
